module.exports = __webpack_public_path__ + "website/img/je-community.90e9a183.svg";